import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import { getStore } from 'owa-mail-list-store/lib/store/Store';
import folderStore from 'owa-folders';
import { getItemToShowFromNodeId } from 'owa-mail-store/lib/utils/conversationsUtils';
import { getFormattedDate } from 'owa-mail-store-actions';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import MailListItemPartIconBar from './MailListItemPartIconBar';
import { computed } from 'mobx';
import { Check } from 'office-ui-fabric-react/lib/Check';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as mailListSelectionActionsV2 from 'owa-mail-actions/lib/mailListSelectionActions';
import Draggable from 'owa-dnd/lib/components/Draggable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { getMailListItemPartDragPreview, MAIL_ITEM_DRAG_XOFFSET, MAIL_ITEM_DRAG_YOFFSET, } from '../utils/mailListDragUtil';
var styles = require('./MailListItemPart.scss');
var classNames = require('classnames/bind');
var MailListItemPartComputedState = /** @class */ (function () {
    function MailListItemPartComputedState(tableViewId, nodeId) {
        this.tableViewId = tableViewId;
        this.nodeId = nodeId;
    }
    Object.defineProperty(MailListItemPartComputedState.prototype, "isChecked", {
        get: function () {
            var expandedConversationViewState = getStore().expandedConversationViewState;
            return (expandedConversationViewState.selectedNodeIds.length > 1 &&
                expandedConversationViewState.selectedNodeIds.indexOf(this.nodeId) > -1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailListItemPartComputedState.prototype, "isSelected", {
        get: function () {
            var expandedConversationViewState = getStore().expandedConversationViewState;
            return (expandedConversationViewState.selectedNodeIds.length == 1 &&
                expandedConversationViewState.selectedNodeIds.indexOf(this.nodeId) > -1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailListItemPartComputedState.prototype, "showHoverActions", {
        get: function () {
            var tableView = getStore().tableViews.get(this.tableViewId);
            if (!tableView) {
                return false;
            }
            return ((tableView.selectedRowKeys.size == 1 && tableView.isInCheckedMode) ||
                (tableView.selectedRowKeys.size <= 1 && !tableView.isInVirtualSelectAllMode));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailListItemPartComputedState.prototype, "showHoverBackground", {
        get: function () {
            var expandedConversationViewState = getStore().expandedConversationViewState;
            return expandedConversationViewState.selectedNodeIds.length == 1;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], MailListItemPartComputedState.prototype, "isChecked", null);
    tslib_1.__decorate([
        computed
    ], MailListItemPartComputedState.prototype, "isSelected", null);
    tslib_1.__decorate([
        computed
    ], MailListItemPartComputedState.prototype, "showHoverActions", null);
    tslib_1.__decorate([
        computed
    ], MailListItemPartComputedState.prototype, "showHoverBackground", null);
    return MailListItemPartComputedState;
}());
var MailListItemPart = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemPart, _super);
    function MailListItemPart(props) {
        var _this = _super.call(this, props) || this;
        // In checked mode we have the parent container be draggable
        _this.canDrag = function () {
            return (isMailFeatureEnabled('tri-superConversationExpansion') &&
                getStore().expandedConversationViewState.selectedNodeIds.indexOf(_this.props.nodeId) ==
                    -1);
        };
        _this.getDragData = function () {
            var item = getItemToShowFromNodeId(_this.props.nodeId);
            return {
                itemType: DraggableItemTypes.MailListItemPart,
                tableViewId: _this.props.tableViewId,
                subjects: [item.Subject ? item.Subject : strings.noSubject],
                itemIds: [item.ItemId.Id],
            };
        };
        _this.initializeMailListComputedState(props);
        return _this;
    }
    MailListItemPart.prototype.render = function () {
        var _this = this;
        var item = getItemToShowFromNodeId(this.props.nodeId);
        var tableView = getStore().tableViews.get(this.props.tableViewId);
        var itemPartClasses;
        if (item) {
            itemPartClasses = classNames(styles.itemPart, !item.IsRead && styles.unread, this.computedState.showHoverActions && styles.showHoverActionsOnHover, this.computedState.showHoverBackground && styles.showHoverStyles, item.IsDraft && styles.itemPartContentDraft);
        }
        return (item && (React.createElement(Draggable, { canDrag: this.canDrag, getDragData: this.getDragData, getDragPreview: getMailListItemPartDragPreview, xOffset: MAIL_ITEM_DRAG_XOFFSET, yOffset: MAIL_ITEM_DRAG_YOFFSET },
            React.createElement("div", { key: item.ItemId.Id, className: itemPartClasses, onClick: function () {
                    mailListSelectionActionsV2.itemPartClicked(_this.props.nodeId, item.ItemId.Id, tableView);
                } }, this.props.isSingleLine
                ? this.renderSingleLineViewMailListItemPart()
                : this.renderThreeColumnViewMailListItemPart()))));
    };
    MailListItemPart.prototype.renderThreeColumnViewMailListItemPart = function () {
        var item = getItemToShowFromNodeId(this.props.nodeId);
        var senderName = item.From && item.From.Mailbox && item.From.Mailbox.Name;
        var parentFolder = folderStore.folderTable.get(item.ParentFolderId.Id);
        var timeText = !parentFolder || getFolderIdForSelectedNode() == parentFolder.FolderId.Id
            ? getFormattedDate(item.DateTimeReceived)
            : parentFolder.DisplayName;
        var senderClasses = classNames(!item.IsRead ? styles.senderUnread : styles.sender, item.IsDraft && styles.draft);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.mailListItemPartFirstColumnThreeColumnView }, isMailFeatureEnabled('tri-superConversationExpansion') &&
                this.renderFirstColumnContent()),
            React.createElement("div", { className: styles.mailListItemPartSecondColumnThreeColumnView },
                React.createElement("span", { className: senderClasses }, item.IsDraft ? strings.draftSenderPersonaPlaceholder : senderName)),
            React.createElement("div", { className: styles.mailListItemPartThirdColumnThreeColumnView },
                React.createElement("span", { className: styles.itemPartTime }, timeText),
                this.renderIconBar())));
    };
    MailListItemPart.prototype.renderSingleLineViewMailListItemPart = function () {
        var item = getItemToShowFromNodeId(this.props.nodeId);
        var senderName = item.From && item.From.Mailbox && item.From.Mailbox.Name;
        var parentFolder = folderStore.folderTable.get(item.ParentFolderId.Id);
        var timeText = !parentFolder || getFolderIdForSelectedNode() == parentFolder.FolderId.Id
            ? getFormattedDate(item.DateTimeReceived)
            : parentFolder.DisplayName;
        var senderClasses = classNames(!item.IsRead ? styles.senderUnread : styles.sender, item.IsDraft && styles.draft);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.mailListItemPartFirstColumnSingleLineView }, isMailFeatureEnabled('tri-superConversationExpansion') &&
                this.renderFirstColumnContent()),
            React.createElement("div", { className: styles.mailListItemPartSecondColumnSingleLineView },
                React.createElement("span", { className: senderClasses }, item.IsDraft ? strings.draftSenderPersonaPlaceholder : senderName),
                this.renderIconBar()),
            React.createElement("div", { className: styles.mailListItemPartThirdColumnSingleLineView },
                React.createElement("span", { className: styles.itemPartTime }, timeText))));
    };
    MailListItemPart.prototype.initializeMailListComputedState = function (props) {
        this.computedState = new MailListItemPartComputedState(props.tableViewId, props.nodeId);
    };
    MailListItemPart.prototype.renderFirstColumnContent = function () {
        var _this = this;
        if (this.computedState.isSelected) {
            return React.createElement(Icon, { iconName: "CheckMark" /* CheckMark */ });
        }
        else {
            var checkBoxClassNames = classNames(styles.itemPartCheckboxContainer, this.computedState.isChecked && styles.showCheckbox);
            return (React.createElement("div", { onClick: function (evt) {
                    evt.stopPropagation();
                    mailListSelectionActionsV2.toggleSelectItemPart(_this.props.nodeId);
                } },
                React.createElement(Check, { className: checkBoxClassNames, checked: this.computedState.isChecked })));
        }
    };
    MailListItemPart.prototype.renderIconBar = function () {
        return (React.createElement(MailListItemPartIconBar, { nodeId: this.props.nodeId, tableViewId: this.props.tableViewId, isSingleLine: this.props.isSingleLine, tableViewSupportsFlagging: this.props.tableViewSupportsFlagging }));
    };
    MailListItemPart = tslib_1.__decorate([
        observer
    ], MailListItemPart);
    return MailListItemPart;
}(React.Component));
export default MailListItemPart;
//# sourceMappingURL=MailListItemPart.js.map